export default __webpack_public_path__ + "static/media/import-csv-example-prices.749cc81f.csv";